import { render, staticRenderFns } from "./MyVCurrencyField.vue?vue&type=template&id=8c926c2c"
import script from "./MyVCurrencyField.vue?vue&type=script&lang=js"
export * from "./MyVCurrencyField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports